module.exports = __webpack_public_path__ + "img/40_69_007_850.31cbd765.jpg";